import { createSlice } from "@reduxjs/toolkit";

export const expensesListsSlice = createSlice({
  name: "expensesLists",
  initialState: {
    init: false,
    data: [],
    showArchived: false,
    selectedModal: null,
  },
  reducers: {
    addExpensesList: (state, action) => {
      state.data.push(action.payload);
    },
    setData: (state, action) => {
      state.data = action.payload;
      state.init = true;
    },
    setShowArchived: (state, action) => {
      state.showArchived = action.payload;
    },
    setSelectedModal: (state, action) => {
      state.selectedModal = action.payload;
    },
    updateExpensesListWidget: (state, action) => {
      const { id, widget } = action.payload;
      const expensesList = state.data.find((item) => item.id === id);
      if (expensesList) {
        expensesList.widget = widget;
      }
    },
  },
});

export const {
  addExpensesList,
  setData,
  setShowArchived,
  setSelectedModal,
  updateExpensesListWidget,
} = expensesListsSlice.actions;

export default expensesListsSlice.reducer;
